// extracted by mini-css-extract-plugin
module.exports = {"menu":"styles_menu__3PdMa","menuItem":"styles_menuItem__1k_2z"};